const VAT_REASON_WIRE = {
    RESIDENTIAL_EXEMPT: 1,
    NOT_A_VAT_PAYER: 2,
    ART_145_EXEMPTION: 3,
    USN_REDUCED: 4,
    STANDARD: 5,
    AGENCY_PASS_THROUGH: 6,
};
const WIRE_TO_VAT_REASON = new Map(Object.entries(VAT_REASON_WIRE).map(([reason, wire]) => [wire, reason]));
/**
 * DB/domain reason → proto enum number; 0 (UNSPECIFIED) for null/absent.
 * Callers assign the result into a generated enum field with a plain `as`
 * cast — a numeric widening, not a semantic one.
 */
export function vatReasonToWire(reason) {
    return reason ? (VAT_REASON_WIRE[reason] ?? 0) : 0;
}
/** Proto enum number → domain union; undefined for 0 or unknown values. */
export function vatReasonFromWire(wire) {
    return wire == null ? undefined : WIRE_TO_VAT_REASON.get(wire);
}
